import React, {
	FunctionComponent,
	useLayoutEffect,
	useRef,
	useState,
} from "react";
import { Box, Typography } from "@mui/material";
import styles from "./cardItem.module.css";

interface Props {
	text: string;
	maxHeight?: string;
}

const DocumentText: FunctionComponent<Props> = ({
	text,
	maxHeight = "150px",
}) => {
	const wrapperRef = useRef<HTMLDivElement>(null);
	const [isOverflowing, setIsOverflowing] = useState(false);

	useLayoutEffect(() => {
		const el = wrapperRef.current;
		if (!el) return;
		setIsOverflowing(el.scrollHeight > el.clientHeight);
	}, [text, maxHeight]);

	return (
		<Box
			ref={wrapperRef}
			sx={{ height: maxHeight, "--max-height": maxHeight } as any}
			className={`${styles.cardBodyWrapper} ${
				isOverflowing ? styles.fade : ""
			}`}
		>
			<Typography variant="body2" className={styles.cardBody}>
				{text}
			</Typography>
		</Box>
	);
};

export default DocumentText;
